import React from "react";
import Styles from "./Assistance.module.css";
import Star from "Assets/Homepage/star2.png";
import { FaArrowRightLong } from "react-icons/fa6";

function Assistance() {
    return (
        <div className={Styles["Assistance"]}>
            <div>
                <h3>W4 Assistance </h3>
                <p>
                    Serene Tax can help find you any new tax deductions and
                    credits personalized to you and your unique changes to be
                    done in your w2.
                </p>
                <div className={Styles["list"]}>
                    <p>
                        <span>01</span> Got Married
                    </p>
                    <p>
                        <span>02</span> Had a baby
                    </p>
                    <p>
                        <span>03</span> Changed employee?
                    </p>
                    <p>
                        <span>04</span> any salary bonuses?
                    </p>
                </div>
            </div>
            {/*  <div className={Styles["view-more"]}>
                <img src={Star} alt="" />
                <button>
                    View All <FaArrowRightLong />
                </button>
            </div> */}
            <div>
                <h3>Bookkeeping </h3>
                <p>
                    Bookkeeping services involve recording, organizing, and
                    maintaining the financial transactions of a business. These
                    services are foundational to managing a company's finances,
                    ensuring compliance, and enabling effective decision-making.
                    Bookkeepers handle day-to-day financial tasks, such as
                </p>
                <div className={Styles["list"]}>
                    <p>
                        <span>01</span> Recording Transactions
                    </p>
                    <p>
                        <span>02</span> Reconciliation
                    </p>
                    <p>
                        <span>03</span> Accounts Payable and Receivable
                        Management
                    </p>
                    <p>
                        <span>04</span> Expense Management
                    </p>
                </div>
            </div>
        </div>
    );
}

export default Assistance;
